import React from 'react';
import {getDateFormatted,getStatusValue,getStatusMessageValue} from '../utils/utils'

function TableStepsOrder(props) {
    return (
        <div className="">
          <div className="row order-steps-title">
            <div className="col-3">DATA</div>
            <div className="col-8">STATO</div>
          </div>
          <div className='dettaglio-steps'>
            {props.order.refunded_timestamp ? 
              <div className="row">
                  <div  className="col-3">{getDateFormatted(props.order.refunded_timestamp.split("T"))}</div>
                  <div className="col-8">{getStatusValue('refunded','IT')}</div>
              </div>:null}
            {props.order.completed_timestamp ? 
              <div className="row">
                  <div className="col-3">{getDateFormatted(props.order.completed_timestamp.split("T"))}</div>
                  <div  className="col-8">{getStatusValue('completed','IT')}</div>
              </div>:null}    
            {props.order.shipping_timestamp ? 
              <div className="row">
                  <div className="col-3">{getDateFormatted(props.order.shipping_timestamp.split("T"))}</div>
                  <div  className="col-8">{getStatusValue('shipped','IT')}</div>
              </div>:null}  
            {props.order.under_processing_timestamp ? 
              <div className="row">
                  <div  className="col-3">{ getDateFormatted(props.order.under_processing_timestamp.split("T"))}</div>
                  <div  className="col-8">{getStatusValue('under_processing','IT')}</div>
              </div>:null}  
            {props.order.payment_timestamp ? 
              <div className="row">
                  <div  className="col-3">{getDateFormatted(props.order.payment_timestamp.split("T"))}</div>
                  {props.order.isPaid ? 
                    <div  className="col-8">{getStatusValue('paid','IT')}</div>
                    :
                      <div  className="col-8">{getStatusValue('submitted_for_settlement','IT')}
                        <span className="d-inline-block" tabindex="0" data-toggle="tooltip" title={getStatusMessageValue('submitted_for_settlement','IT')}>
                          <i className="fa fa-info-circle" style={{marginLeft:"5px"}}></i>
                        </span>
                      </div>
                    }
              </div>:null}  
              {props.order.confirmed_timestamp ? 
              <div className="row">
                  <div className="col-3">{getDateFormatted(props.order.confirmed_timestamp.split("T"))}</div>
                  <div  className="col-8">{getStatusValue('confirmed','IT')}</div>
              </div>:null}
              <div className="row">
              <div className="col-3">{ getDateFormatted(props.order.timestamp.split("T"))}</div>
              <div  className="col-8">{getStatusValue('created','IT')}</div>
              </div>
          </div>
    </div>
    );
}

export default TableStepsOrder;